import request from "../request";
import Url from "../url/work";

const getPersonalGoalsDatasByMemberid = ({
  path = "",
  data,
  options = {},
} = {}) => {
  return request.get(Url.getPersonalGoalsDatasByMemberid + path, data, options);
};
const getMyPersonalGoalsDatas = ({ path = "", data, options = {} } = {}) => {
  return request.get(Url.getMyPersonalGoalsDatas + path, data, options);
};
const getgetMyPersonalGoalsDatasDetails = ({
  path = "",
  data,
  options = {},
} = {}) => {
  return request.get(
    Url.getgetMyPersonalGoalsDatasDetails + path,
    data,
    options
  );
};
const setPersonalGoalsDatas = ({ path = "", data, options = {} } = {}) => {
  return request.post(Url.setPersonalGoalsDatas + path, data, options);
};
const updatePersonalGoalsDatas = ({ path = "", data, options = {} } = {}) => {
  return request.post(Url.updatePersonalGoalsDatas + path, data, options);
};

const getDoRateListByMemberid = ({ path = "", data, options = {} } = {}) => {
  return request.get(Url.getDoRateListByMemberid + path, data, options);
};
const getMyDoRateList = ({ path = "", data, options = {} } = {}) => {
  return request.get(Url.getMyDoRateList + path, data, options);
};
const setDoRate = ({ path = "", data, options = {} } = {}) => {
  return request.post(Url.setDoRate + path, data, options);
};
const updateDoRate = ({ path = "", data, options = {} } = {}) => {
  return request.post(Url.updateDoRate + path, data, options);
};

export default {
  getPersonalGoalsDatasByMemberid,
  getMyPersonalGoalsDatas,
  getgetMyPersonalGoalsDatasDetails,
  setPersonalGoalsDatas,
  updatePersonalGoalsDatas,

  getDoRateListByMemberid,
  getMyDoRateList,
  setDoRate,
  updateDoRate,
};
